import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { BusinessSetupBusinessType } from 'src/shared/graphql/appsync.full';
import {
  LtdPlan,
  MurshePlanStyled,
  PaturPlanStyled,
  PlanItemContainer,
  PlanItemCurrency,
  PlanItemHeader,
  PlanItemList,
  PlanItemListDetail,
  PlanItemPeriod,
  PlanItemPrice,
  PlanItemPriceWrapper,
  PlanItemTitle,
  PlanItemWrapper,
} from 'src/styles/infoPages';

interface PlanItemProps {
  title: string;
  price: string;
  icon: BusinessSetupBusinessType;
  vat?: boolean;
  items: Array<string>;
}

const PlanItem: React.FC<PlanItemProps> = ({ icon, title, price, items, vat }) => {
  const { t } = useTranslation();

  return (
    <PlanItemWrapper>
      <PlanItemContainer>
        <PlanItemHeader>
          {icon === BusinessSetupBusinessType.PATUR ? (
            <PaturPlanStyled />
          ) : icon === BusinessSetupBusinessType.MURSHE ? (
            <MurshePlanStyled />
          ) : icon === BusinessSetupBusinessType.LTD ? (
            <LtdPlan />
          ) : null}
          <div>
            <PlanItemTitle>{title}</PlanItemTitle>
            <PlanItemPriceWrapper>
              <PlanItemPrice>{price}</PlanItemPrice>
              <PlanItemCurrency>
                {t('currencies.ILS')} {vat ? t('solutions.vat') : t('solutions.includVat')}
              </PlanItemCurrency>
              <PlanItemPeriod>/{t('solutions.monthly')}</PlanItemPeriod>
            </PlanItemPriceWrapper>
          </div>
        </PlanItemHeader>

        <PlanItemList>
          {items.map((text, index) => (
            <PlanItemListDetail key={index}>{text}</PlanItemListDetail>
          ))}
        </PlanItemList>
      </PlanItemContainer>
    </PlanItemWrapper>
  );
};

export default PlanItem;
